import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Space, Spin } from "antd";
import React from "react";
import PageTitle from "./PageTitle";
import SearchControl from "./SearchControl";

const PageContext = React.createContext(null);

const usePageContext = () => {
  const context = React.useContext(PageContext);
  if (!context) {
    throw new Error("InputGroup compound components cannot be rendered outside the InputGroup component");
  }
  return context;
};

/**
 *
 * @param param0 Props for the title and subtitle on the page summary
 * @returns Title Component
 */
const Title = ({ ...props }) => {
  return (
    <Row>
      <PageTitle icon={<FontAwesomeIcon icon={["fas", props.icon]} />} title={props.title} hideBreadcrumb={props.hideBreadcrumb} />
    </Row>
  );
};

/**
 *
 * @param param0 Children components to go in the detail section
 * @returns Toolbar component
 */
const Toolbar = ({ ...props }) => {
  return <Space>{props.children}</Space>;
};

/**
 *
 * @param param0 Children components to go in the detail section
 * @returns Details component
 */
type SearchControlProps = {
  onSearch?: (e) => void;
  dataSet?: unknown;
  fields?: unknown;
  onConditionChange: (e) => void;
  onSearchChange: (e) => void;
  onCivilScreen?: boolean;
  conditionSearch?: string;
  conditionValue?: string;
  isReturn?: boolean;
  onNewSearch?: (e) => void;
  fromPage?: boolean;
  loading?: boolean;
};
const Controls = ({ ...props }: SearchControlProps) => {
  return (
    <SearchControl
      onCivilScreen={props.onCivilScreen}
      onConditionChange={props.onConditionChange}
      onSearchChange={props.onSearchChange}
      onSearch={props.onSearch}
      dataSet={props.dataSet}
      fields={props.fields}
      conditionSearch={props.conditionSearch}
      conditionValue={props.conditionValue}
      isReturn={props.isReturn}
      onNewSearch={props.onNewSearch}
      fromPage={props.fromPage}
      loading={props.loading}
    />
  );
};

/**
 *
 * @param props
 * @returns
 */
const Content = ({ ...props }) => {
  return <>{props.children}</>;
};

/**
 *
 * @param props Accepts the props for its own children
 * @returns PageSummary
 */
const Page = ({ ...props }) => {
  return (
    <PageContext.Provider value={props}>
      <Space direction="vertical" size={16}>
        {props.loading ? <Spin size="large" /> : props.children}
      </Space>
    </PageContext.Provider>
  );
};

/**
 * Assign the PageSummary its compound component fragments
 */
Page.Title = Title;
Page.Toolbar = Toolbar;
Page.Controls = Controls;
Page.Content = Content;

export default Page;
